import { ApiResponse } from '@/interfaces/apiresponse.interface';
import { CreateAccessRequest } from '@/interfaces/createAccessRequest.interface';
import { EngagementAccessDTO } from '@/interfaces/engagementAccessDTO.interface';
import { EngagementResponse } from '@/interfaces/engagementResponse.interface';
import { AppNav } from '@/routes/app-nav';
import { EngagementAccessService } from '@/services/engagement-access.service';
import { TitleService } from '@/services/title.service';
import Helpers from '@/shared/helpers';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-request-access-dialog',
  standalone: false,
  templateUrl: './request-access-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./request-access-dialog.component.scss']
})
export class RequestAccessDialogComponent implements OnChanges{

  @Input()
  public engagement?: EngagementResponse;

  @Input()
  public showing: boolean = false;
  
  @Output()
  public showingChange = new EventEmitter<boolean>();

  @Output()
  public onShouldUpdate = new EventEmitter();

  private helpers: Helpers;

  public approveUsers: any[] = [];
  
  public messageKey: string = "requestAccessPage";
  public approvedAndPendingUsers: EngagementAccessDTO[] = [];
  public usersWithoutAccess: EngagementAccessDTO[] = [];
  public loading: boolean = true;
  public loadingUsersWithoutAccess: boolean = true;
  public requestLoading: boolean = false;
  
  @ViewChild(Table) engagementEntryTable!: Table;

  constructor(
    private titleService: TitleService,
    private translocoService: TranslocoService,
    private messageService: MessageService,
    private engagementAccessService: EngagementAccessService,
  ) {
    this.helpers = Helpers.getInstance(this.translocoService);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.engagement){
      this.loadEngagementAccessEntries();
    }
    if(changes.showing){
     this.approveUsers = []; 
    }
  }

  ngOnInit(): void {
    this.titleService.setTitle(AppNav.StatusMonitor.title);
    this.loadEngagementAccessEntries();
  };


  loadEngagementAccessEntries(): void {
    this.loading = true;
    this.loadingUsersWithoutAccess = true;
    if(!this.engagement || !this.engagement.id){
      return;
    }
    this.engagementAccessService.approvedAndPendingUsers(this.engagement.id)
      .then(
        (response: HttpResponse<ApiResponse>) => {
          this.loading = false;
          const entries = (response.body || []) as EngagementAccessDTO[];
          this.approvedAndPendingUsers = entries;
        },
        (response: HttpErrorResponse) => {
          this.loading = false;
          this.helpers.showApiResponseMessage(response, this.messageService, this.messageKey);
        }
      );

      this.engagementAccessService.usersWithoutAccess(this.engagement.id)
        .then(
          (response: HttpResponse<ApiResponse>) => {
            this.loadingUsersWithoutAccess = false;
            const entries = (response.body || []) as EngagementAccessDTO[];
            this.usersWithoutAccess = entries;
          },
          (response: HttpErrorResponse) => {
            this.loadingUsersWithoutAccess = false;
            this.helpers.showApiResponseMessage(response, this.messageService, this.messageKey);
          }
        );
  }
  
  createAccessRequests(){
    //Create
    if(this.approveUsers.length == 0){
        this.messageService.add({
          key: 'create_access_requests_empty_data',
          severity: 'error',
          summary: this.translocoService.translate('create_access_requests_message_empty_data'),
          life: 15000
      });
      return;
    }
    this.requestLoading = true;
    const accessRequests: CreateAccessRequest[] = [];
    for(const approvedUser of this.approveUsers){
      const accessRequest: CreateAccessRequest = {
        engagementId: this.engagement?.id ?? '0',
        requestorEmail: approvedUser.userEmail
      }
      accessRequests.push(accessRequest);
    }
    this.engagementAccessService.createRequests(accessRequests)
      .then(
        (response: HttpResponse<ApiResponse>) => {
          this.showingChange.emit(false);
          this.onShouldUpdate.emit();
          this.helpers.showApiResponseMessage(response, this.messageService, this.messageKey);
          this.loadEngagementAccessEntries();
        },
        (response: HttpErrorResponse) => {
          this.helpers.showApiResponseMessage(response, this.messageService, this.messageKey);
        }
      )
      .finally(() => {
        this.requestLoading = false;
      });
  }
}
